/** Звать синхронно в клике: Safari засчитывает жест только записи, начатой до первого await. null — копировать нечего. */
export function writeToClipboard(
  text: string | Promise<string | null>,
  fallback: (value: string) => boolean,
): Promise<boolean | null> {
  if (typeof text === 'string') return writeText(text, fallback);

  const value: Promise<string | null> = text.then((resolved: string | null) => resolved || null);
  const writeLater = async (): Promise<boolean | null> => {
    const resolved: string | null = await value;
    return resolved === null ? null : writeText(resolved, fallback);
  };

  if (typeof ClipboardItem === 'undefined' || !navigator.clipboard?.write) return writeLater();

  const blob: Promise<Blob> = value.then((resolved: string | null) => {
    if (resolved === null) throw new Error('nothing to copy');
    return new Blob([resolved], { type: 'text/plain' });
  });
  // Отказ читает сам буфер; браузер, который так и не прочёл элемент, не должен оставить его необработанным.
  blob.catch(() => undefined);

  // Итог — только вместе с самим текстом: вызывающий сообщает, что скопировано, и текст к этому моменту уже есть.
  const written = async (): Promise<boolean | null> => ((await value) === null ? null : true);

  // Браузер, где ClipboardItem не принимает промис, бросает синхронно — тогда пишем текст по готовности.
  let write: Promise<void>;
  try {
    write = navigator.clipboard.write([new ClipboardItem({ 'text/plain': blob })]);
  } catch {
    return writeLater();
  }

  return write.then(written, writeLater);
}

async function writeText(value: string, fallback: (value: string) => boolean): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return fallback(value);
  }
}
